export const STAKING_DURATION_OPTIONS = [
  { label: "180天", value: 180 },
  { label: "360天", value: 360 },
];

/** 未从链接获取上级地址时使用的默认上级 */
export const DEFAULT_PARENT_ADDRESS =
  "0x1345Da3465d5C265B17ec7e0AC32b9336AE55614";

export const EMPTY_PERSONAL_INFO = {
  goldCards: 0,
  silverCards: 0,
  bronzeCards: 0,
  totalCards: 0,
  cardBenefit: "0%",
  canExchangeCard: false,
  directPoints: "0",
  teamPoints: "0",
  directPointsRaw: "0",
  teamPointsRaw: "0",
  cardReward: "0 RUSD",
  directReferrals: 0,
  directPerformance: "0 USDT",
  totalPerformance: "0 USDT",
  promotionReward: "0 RUSD",
  withdrawnStaking: "0 RUSD",
  withdrawnPromotion: "0 RUSD",
  withdrawnCard: "0 RUSD",
};

/** 积分兑换卡牌配置（cardType 对应合约 Stake.CardType 枚举） */
export const CARD_EXCHANGE_OPTIONS = [
  {
    cardType: 3,
    label: "铜卡",
    directNeed: 20000,
    teamNeed: 50000,
  },
  {
    cardType: 2,
    label: "银卡",
    directNeed: 50000,
    teamNeed: 100000,
  },
  {
    cardType: 1,
    label: "金卡",
    directNeed: 100000,
    teamNeed: 200000,
  },
];

/** 积分与链上 raw 值换算（与 formatTokenAmount 18 位小数一致） */
const EXCHANGE_POINT_FACTOR = 10n ** 18n;

/** 单张卡牌权益加成（百分比） */
export const CARD_BENEFIT_RATES = {
  gold: 1,
  silver: 0.5,
  bronze: 0.2,
};

function formatBenefitValue(value) {
  return Number.isInteger(value)
    ? String(value)
    : String(value).replace(/\.?0+$/, "");
}

/** PersonalInfo 卡牌权益：各卡加成总和，如两金一银 → +2.5% */
export function calcCardBenefitPercent(goldCards, silverCards, bronzeCards) {
  const total =
    goldCards * CARD_BENEFIT_RATES.gold +
    silverCards * CARD_BENEFIT_RATES.silver +
    bronzeCards * CARD_BENEFIT_RATES.bronze;
  if (total === 0) return "0%";
  return `${formatBenefitValue(total)}%`;
}

/** UserInfoCard 全网权益：按金/银/铜分别展示，如两金一银 → 2%+0.5% */
export function calcCardBenefitRange(goldCards, silverCards, bronzeCards) {
  const parts = [];
  if (goldCards > 0) {
    parts.push(`${formatBenefitValue(goldCards * CARD_BENEFIT_RATES.gold)}%`);
  }
  if (silverCards > 0) {
    parts.push(`${formatBenefitValue(silverCards * CARD_BENEFIT_RATES.silver)}%`);
  }
  if (bronzeCards > 0) {
    parts.push(`${formatBenefitValue(bronzeCards * CARD_BENEFIT_RATES.bronze)}%`);
  }
  if (parts.length === 0) return "0%";
  return parts.join("+");
}

export function canExchangeCardType(directPoints, teamPoints, cardType) {
  const option = CARD_EXCHANGE_OPTIONS.find(
    (item) => item.cardType === cardType
  );
  if (!option) return false;
  const directThreshold = BigInt(option.directNeed) * EXCHANGE_POINT_FACTOR;
  const teamThreshold = BigInt(option.teamNeed) * EXCHANGE_POINT_FACTOR;
  return (
    BigInt(directPoints) >= directThreshold &&
    BigInt(teamPoints) >= teamThreshold
  );
}

export function canExchangeAnyCard(directPoints, teamPoints) {
  return CARD_EXCHANGE_OPTIONS.some((item) =>
    canExchangeCardType(directPoints, teamPoints, item.cardType)
  );
}

/** 持卡用户展示信息（按最高等级卡牌） */
export const CARD_USER_PROFILE = {
  gold: {
    title: "尊敬的金卡用户",
    avatarSrc: require("@/assets/image/rad_card2.png"),
  },
  silver: {
    title: "尊敬的银卡用户",
    avatarSrc: require("@/assets/image/rad_card1.png"),
  },
  bronze: {
    title: "尊敬的铜卡用户",
    avatarSrc: require("@/assets/image/rad_card3.png"),
  },
};
